"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cantiano": {
    "07316c57": [{
      "hkey": "3d830e9b",
      "slug": "chiaserna-fossato",
      "name": "Chiaserna-Fossato",
      "primary": true,
      "skipSearch": false
    }],
    "chiaserna": [{
      "hkey": "3d830e9b",
      "slug": "chiaserna-fossato",
      "name": "Chiaserna-Fossato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a5f76502": [{
      "hkey": "9198604e",
      "slug": "cantiano",
      "name": "Cantiano",
      "primary": true,
      "skipSearch": false
    }],
    "pontedazzo": [{
      "hkey": "9198604e",
      "slug": "cantiano",
      "name": "Cantiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "288d5b49": [{
      "hkey": "9198604e",
      "slug": "cantiano",
      "name": "Cantiano",
      "primary": true,
      "skipSearch": false
    }],
    "san-crescentino": [{
      "hkey": "9198604e",
      "slug": "cantiano",
      "name": "Cantiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;